export default [
  {
    name: "AirMonitoring",
    path: "/air-monitoring",
    meta: {
      title: "Air Monitoring",
      group: "AirMonitoring",
    },
    component: () => import("./pages/index.vue"),
  },
];
